import { render, staticRenderFns } from "./StatisticCoursesLms.vue?vue&type=template&id=99642a2a&scoped=true&"
import script from "./StatisticCoursesLms.vue?vue&type=script&lang=js&"
export * from "./StatisticCoursesLms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99642a2a",
  null
  
)

export default component.exports